import {
	GetRequestsList,
	CreateS12ThresholdsRequest,
	CreateXMLTopologyRequest,
	DeleteRequest,
	UpdateRequest,
	VTKDataRefreshRequest,
	VTKDataRefreshEmailRequest,
	VTKDataRefreshOneDriveRequest,
} from '../requests/DataManagementRequests';

export const getRequestList = async () => {
	try {
		const response = await GetRequestsList();
		return response.data;
	} catch (error) {
		console.error('Error fetching requests:', error);
		throw error;
	}
};

export const deleteRequestAction = async (userId, name) => {
	try {
		const response = await DeleteRequest(userId, name);
		return response.data;
	} catch (error) {
		console.error('Error deleting request:', error);
		throw error;
	}
};

export const updateRequestAction = async (dto) => {
	try {
		const response = await UpdateRequest(dto);
		return response.data;
	} catch (error) {
		console.error('Error updating request:', error);
		throw error;
	}
};

export const CreateXMLTopologyAction = async (dto) => {
	try {
		const response = await CreateXMLTopologyRequest(dto);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const CreateS12ThresholdsAction = async (dto) => {
	try {
		const response = await CreateS12ThresholdsRequest(dto);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const VTKDataRefreshAction = async (dto) => {
	try {
		const response = await VTKDataRefreshRequest(dto);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const VTKDataRefreshEmailAction = async (dto) => {
	try {
		const response = await VTKDataRefreshEmailRequest(dto);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const VTKDataRefreshOneDriveAction = async (dto) => {
	try {
		const response = await VTKDataRefreshOneDriveRequest(dto);
		return response.data;
	} catch (error) {
		throw error;
	}
};
